import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../data/content';
import { useNavigate } from 'react-router-dom';

const FeaturesPage = () => {
  const { language, direction } = useLanguage();
  const features = content[language].features;
  const navigate = useNavigate();

  return (
    <section className="features" style={{ direction, minHeight: '80vh' }}>
      <h2>{language === 'ar' ? 'مميزات النظام' : 'System Features'}</h2>
      <div className="features-list">
        {features.map((feature) => (
          <div key={feature.id} className="feature-item slide-up">
            <span className="feature-icon">{feature.icon}</span>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
            <ul style={{ textAlign: direction === 'rtl' ? 'right' : 'left', margin: '16px 0' }}>
              {feature.highlights && feature.highlights.map((h, i) => (
                <li key={i} style={{ marginBottom: 4, color: 'var(--color-success)' }}> {h}</li>
              ))}
            </ul>
            <button className="cta-button" onClick={() => navigate(`/features/${feature.id}`)}>
              {language === 'ar' ? 'تفاصيل أكثر' : 'More Details'}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesPage; 